import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

/**
 * 余力 / 寻义工需求监管（平台端）
 * 菜单 route：/idle_energy/need
 */
const idleEnergyRouter: RouteRecordRaw = {
  path: `${roterPre}/idle_energy`,
  name: 'IdleEnergy',
  component: Layout,
  alwaysShow: true,
  meta: {
    title: '余力',
    icon: 's-opportunity',
  },
  children: [
    {
      path: 'need',
      name: 'IdleEnergyNeed',
      meta: {
        title: '寻义工需求监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/idle-energy/need/index.vue'),
    },
    {
      path: 'quota',
      name: 'IdleEnergyQuota',
      meta: {
        title: '发放额度',
        noCache: true,
      },
      component: () => import('@/views/_expand/idle-energy/quota/index.vue'),
    },
    {
      path: 'need/detail',
      name: 'IdleEnergyNeedDetail',
      component: () => import('@/views/_expand/idle-energy/need/detail.vue'),
      meta: {
        title: '需求详情',
        noCache: true,
        activeMenu: `${roterPre}/idle_energy/need`,
      },
      hidden: true,
    },
  ],
};

export default idleEnergyRouter;
